import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import type { OrderEventFF as OrderEventFFType } from '@/types/parcel/orders/orderById.interface';

const OrderEventFF = ({ name, sku, quantity }: OrderEventFFType) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem',
        borderBottom: '1px solid',
        borderColor: theme.palette.grey[500],
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          justifyContent: 'center',
          width: '75%',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: '500',
            '&& span': {
              color: theme.palette.primary.main,
            },
          }}
        >
          Nombre: <span>{name}</span>
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: '500',
            '&& span': {
              color: theme.palette.primary.main,
            },
          }}
        >
          SKU: <span>{sku}</span>
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography fontWeight="500" color={theme.palette.secondary.main}>
          Cantidad
        </Typography>
        <Typography fontWeight="bold" color={theme.palette.primary.main}>
          {quantity}
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderEventFF;
